import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { StringInput } from "~/components";

export const InputSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={4} w="full">
      <StringInput
        id="firstName"
        placeholder={t("onboarding.welcomeNamePage.placeholders.firstName")}
      />
      <StringInput
        id="lastName"
        placeholder={t("onboarding.welcomeNamePage.placeholders.lastName")}
      />
    </Flex>
  );
};
